// Entry for desktop.html — packaging-first, no app refactors.
// Scenario 3.1: Registration-first — move tradingview-universal-chart.js right after providers.
import he from 'he';
if (typeof window !== 'undefined') {
  window.he = he;
}

// Wave-1: bundle A-Frame primitives/components and safe global utilities in desktop load order.
import '../../js/aframe-environment-component.js';
import '../../js/rounded-plane.js';
import '../../js/rounded-box.js';
import '../../js/cube-handler.js';
import '../../js/TickerNewsPlacements.js';
import '../../js/MarketHoursUtility.js';
import '../../js/PolygonAPIManagerV2.js';
import '../../js/PVTechAPIManagerV5.js';
import '../../js/CompanyIconAPIManager.js';
import '../../js/NewsProxyAPIManager.js';
import '../../js/RightPanelProxyAPIManager.js';
import '../../js/NewsapiAPIManager.js';
import '../../js/MediastackAPIManager.js';
// Text/label component used by center cube labels (A-Frame Troika Text)

// Registration-first: ensure A-Frame component is registered before placements/mutators
import '../../js/live-chart-shared/LiveChartAPIManager.js';
import '../../js/live-chart-shared/TradingViewCore.js';
import '../../desktop_scripts/tradingview-universal-chart-v2.js';

// Wave-2 (batch 1): bundle desktop_scripts side-effect modules in order
// These must be loaded in this order for proper initialization
import '../../desktop_scripts/StockCubePlacements.js';
import '../../desktop_scripts/timeline-control.js';
import '../../desktop_scripts/rotation-controls.js';
import '../../desktop_scripts/data-interval-control.js';
import '../../js/fireworks-shared/fireworks-lib-2.js';
import '../../js/fireworks-shared/fireworks-controller-2.js';
import '../../js/market-map-shared/constants.js';
import '../../js/market-map-shared/layout.js';
import '../../js/market-map-shared/rendering.js';
import '../../js/market-map-shared/mode-switching.js';
import '../../js/market-map-shared/buildings-mode.js';
import '../../js/stock-cube-visualizer-shared/index.js';
import '../../desktop_scripts/stock-cube-visualizer/stock-cube-visualizer-desktop.js';
// Legacy center-panel bootstrap (packaging-only, restores pre-Webpack default chart init)
import '../../js/auto-refresh-scheduler-shared.js';
import '../../desktop_scripts/cookie-consent.js';
import '../../desktop_scripts/stock-bar.js';
import '../../desktop_scripts/url-symbol-loader.js';
import '../../desktop_scripts/aframe-main-script.js';

// Wave-2 (batch 2): additional desktop scripts
import '../../desktop_scripts/segments-control.js';
import '../../desktop_scripts/chart-type-carousel.js';
import '../../desktop_scripts/ticker-news.js';
import '../../desktop_scripts/mouse-rotation.js';
import '../../desktop_scripts/chart-interaction-toggle.js';
import '../../desktop_scripts/sectors-assets-pop-up.js';
import '../../desktop_scripts/configure-pop-up.js';
import '../../desktop_scripts/info-popup.js';
import '../../desktop_scripts/theme-control.js';
import '../../desktop_scripts/banners-control.js';
import '../../desktop_scripts/tutorial.js';
import '../../desktop_scripts/fullscreen-control.js';
import '../../desktop_scripts/top-menu-nav-control.js';
import '../../desktop_scripts/sticky-scroll.js';
import '../../desktop_scripts/chart-controls-row.js';

// Right panel data then UI (ensure data ready before UI default init)
import '../../desktop_scripts/right-panel-data-handler.js';
import '../../desktop_scripts/right-panel.js';
import '../../desktop_scripts/right-configure-popup.js';
import '../../desktop_scripts/rp-profile-tab.js';
import '../../desktop_scripts/rp-performance-tab.js';
import '../../desktop_scripts/rp-financials-tab.js';
import '../../desktop_scripts/financials-autoscroll.js';

import '../../desktop_scripts/search-handler.js';

// news graph related
import '../../js/new-graph-shared/news-graph-utils.js';
import '../../js/new-graph-shared/news-graph-physics.js';
import '../../js/new-graph-shared/news-graph-builder.js';
import '../../js/new-graph-shared/news-graph-auto-rotate.js';
import '../../desktop_scripts/news-graph/news-graph-controls.js';
import '../../desktop_scripts/news-graph/news-graph-visualizer.js';
import '../../desktop_scripts/news-graph/controller.js';

import '../../desktop_scripts/watchlist/utils.js';
import '../../desktop_scripts/watchlist/state.js';
import '../../desktop_scripts/watchlist/summary.js';
import '../../desktop_scripts/watchlist/table.js';
import '../../desktop_scripts/watchlist/manager.js';
import '../../desktop_scripts/watchlist/popup.js';
import '../../desktop_scripts/watchlist/csv-parser.js';
import '../../desktop_scripts/watchlist/controller.js';
import '../../desktop_scripts/watchlist/edit-watchlist.js';
import '../../desktop_scripts/watchlist/rp-add-to-watchlist-handler.js';
import '../../js/watchlist-stock-data-processing.js';
import '../../js/watchlist-requests.js';


// account related functionality
import '../../desktop_scripts/settings-popup.js';
import '../../desktop_scripts/account2/auth-ui.js';
import '../../desktop_scripts/account2/email-confirmation-modal.js';
import '../../desktop_scripts/account2/device-link-ui.js';



// User-initiated overlay last among mutators
import '../../desktop_scripts/search-handler.js';

// Flair
// Removed from bundle, now included directly in desktop.html
// import '../../desktop_scripts/fireworks.js';

setCacheItem('preferred-page', 'desktop', 60 * 60 * 24 * 30); // 30 days

console.log('StockStorm: desktop bundle loaded');
